/** Tokens visuais — fotos do evento (mesmo padrão dos recebimentos) */
export const FOTOS_ACCENT = "#F96030";
export const FOTOS_INK = "#1a2035";
export const FOTOS_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const fotosToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${FOTOS_ACCENT}`,
};

export const fotosSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const fotosFilterChipSx = (active: boolean) => ({
  fontWeight: active ? 700 : 500,
  ...(active
    ? {
        bgcolor: FOTOS_ACCENT,
        color: "#fff",
        borderColor: FOTOS_ACCENT,
        "&:hover": { bgcolor: "#e04a1a" },
      }
    : {
        borderColor: "grey.300",
        color: "text.secondary",
        "&:hover": { bgcolor: "grey.50" },
      }),
});

export const fotosFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 44,
  },
};
